import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import 'focus-visible';

// have to call ponyfill because it is a pony and not a poly
import cssVars from 'css-vars-ponyfill';

cssVars({});
